export enum BuyerType {
    Person = 'Person', LegalEntity = 'Legal Entity'
}